import styled from 'styled-components'
import { NATIVE_BASE_COLORS, FONT_SIZE, COLOR } from '../../themes'

export const StyleRadioButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .radio-layout {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 12px 16px;
    border: 1.5px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #FFFFFF;
    gap: 10px;
    min-height: 48px;
    box-sizing: border-box;

    &:hover {
      border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    }

    &.active {
      border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
      background: ${({ colorTheme }) => (colorTheme || COLOR.GOLD_1)}33;
    }

    &.disabled {
      background: ${COLOR.GRAY_13};
      border-color: ${NATIVE_BASE_COLORS.TEXT[300]};
      cursor: not-allowed;
      pointer-events: none;
    }
  }

  .custom-radio {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1.5px solid ${COLOR.GRAY_5};
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .radio-layout.active .custom-radio {
    border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-width: 2.5px;
  }

  .radio-layout.disabled .custom-radio {
    border-color: ${NATIVE_BASE_COLORS.TEXT[500]};
  }

  .inner-circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }

  .radio-layout.disabled .inner-circle {
    background-color: ${NATIVE_BASE_COLORS.TEXT[500]};
  }

  .radio-option {
    font-family: 'NunitoSans', sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: ${COLOR.BLACK_6};
    margin: 0;
    cursor: pointer;
  }

  .disabled {
    cursor: not-allowed !important;
    color: ${COLOR.GRAY_24} !important;
  }
`

